var ModalHelper = {


  initOnce: function() {

    if (this.isInitialized)
      return;

    //Шаблона модального окна
    const $modalTmpl = $('#modal-tmpl');
    if ($modalTmpl.length === 0) {
      throw new Exception('Не найден шаблон диалога #modal-tmpl');
    }
    this.modalTmpl = $modalTmpl.html();

    //Шаблон отображения ошибки загрузки модального окна
    const $modalError = $('#modal-load-content-error');
    if ($modalError.length === 0) {
      throw new Exception('Не найден шаблон диалога #modal-load-content-error');
    }
    this.modalErrorTmpl = $modalError.html();
  },

  create: function(tmplName) {
    this.initOnce();

    const htmlContent = $(tmplName).html();
    const $modal = $(this.modalTmpl).appendTo('body');
    $modal.find('.modal-content').html(htmlContent);
    
    $modal.busy = function(isBusy) {
      if (isBusy === undefined)
        isBusy = true;
      this.toggleClass('busy', isBusy);
      return this;
    };
    
    $modal.content = function(content) {
      this.find('.modal-content').html(content);
      return this;
    };

    $modal.show = function() {
      //$modal.find('.modal-content').height($(window).height() * 0.65);
      $modal.modal({ backdrop: 'static' });
      return this;
    };

    $modal.hide = function() {
      this.modal('hide');
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open').removeAttr('style');
    };

    return $modal;
  },

  showError: function($modal) {
    $modal.content(this.modalErrorTmpl);
    return $modal;
  }
};
